import { useEffect, useState } from "react";
import { getSrcOfIframe } from "../embedUtilities";

const UseGiphyPreview = (url:string, isLoading: boolean, setIsLoading: any, setDisableUpload: any) => {
    const [id, setId] = useState<string>('');

    useEffect(() => {
      if (url) {
        setIsLoading(true)
        setId('');
        getGiphyEmbedId(url)
      }
    },[])

    useEffect(()=> {
      if (id) {
        setDisableUpload(false);
      } else {
        setDisableUpload(true);
      }
      setIsLoading(false);
    }, [id, isLoading])
  
    function getGiphyEmbedId(giphyUrl: string){
      let newId = "";

      if (giphyUrl.includes('gif') || giphyUrl.includes('giphy')) {
          // user enters the complete iframe embed
          if(giphyUrl.includes('<iframe')) {
            newId = getSrcOfIframe(giphyUrl).split('embed/')[1];
          }
          // user enters giphy embed url
          else if(giphyUrl.includes('embed/') && giphyUrl.startsWith('http')) {
            newId = giphyUrl.split('embed/')[1]
          }

          // user enters giphy share link
          else if(giphyUrl.includes('media.giphy')) {
            let giphyUrlParts = giphyUrl.split('/')
            newId = giphyUrlParts[giphyUrlParts.length -2]
          }

          // giphy url for gifs
          else if(giphyUrl.includes('/gifs/')) {
            let nameParts = giphyUrl.split('/gifs/')[1].split('-')
            newId = nameParts[nameParts.length -1];
          }

          // giphy url for clips
          else if(giphyUrl.includes('/clips/')) {
            let nameParts = giphyUrl.split('/clips/')[1].split('-')
            newId = nameParts[nameParts.length -1];
          }
      }
      setId(newId)
      setIsLoading(false);
    }

    return {id}
}

export default UseGiphyPreview
